import { types } from 'mobx-state-tree'
import { user_by_id } from '../api'

const UserByIdStore = types.model({
  loaded: types.optional(types.boolean, false),
  data: types.optional(types.frozen, [])
}).actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get (id, token) {
      user_by_id(id, token).then(
        self.fetch
      )
    },
    fetch (data) {
      self.data = data
      self.loaded = true
    },
    clean () {
      console.log('UserByIdStore - clean() - self:', self)
      self.data = null
      self.loaded = false
    }
  })
)

export default UserByIdStore



// WEBPACK FOOTER //
// ./src/stores/UserByIdStore.js